/**
 * Handles the flow of the month input in terms of formatting.
 */
export default function getFormattedMonth(input: string) {
	if (input === '1') return input;
	const inputAsNumber = parseInt(input);
	if (inputAsNumber <= 19 && inputAsNumber > 12) {
		return '1';
	}
	if (inputAsNumber < 1 && inputAsNumber === 0) {
		return '0';
	}
	if (inputAsNumber <= 12) {
		return input.length === 1 ? '0' + input : input;
	}
	return '';
}
